export default "__VITE_ASSET__BDUWeW6X__"